ApiError = require 'network/api-error'
HandlePendingOrganizationComponent = require 'views/enterprise/dashboard/handle-pending-organization-component'
BulkActionsComponent = require 'views/enterprise/dashboard/bulk-actions-component'
Controller = require 'controller'
FiltersComponent = require 'views/enterprise/dashboard/filters-component'
FilterPopOverButtonComponent = require 'views/enterprise/dashboard/filters/popover-button-component'
GroupListPopOverComponent = require 'views/enterprise/dashboard/group-list-popover-component'
PendingOrganizationMembersComponent = require 'views/enterprise/dashboard/pending-organization-members-component'
MainContentComponent = require 'views/enterprise/dashboard/main-content-component'
ListComponent = require 'views/enterprise/dashboard/list-component'
TeamsSettingsComponent = require 'views/enterprise/dashboard/teams-settings/teams-settings-component'
OrganizationRestrictBoardVisibilityView = require 'views/enterprise/dashboard/teams-settings/organization-restrict-board-visibility-view'
OrganizationRestrictExternalMembersView = require 'views/enterprise/dashboard/teams-settings/organization-restrict-external-members-view'
OrganizationRestrictVisibilityView = require 'views/enterprise/dashboard/teams-settings/organization-restrict-visibility-view'
OrganizationRestrictMembershipView = require 'views/enterprise/dashboard/teams-settings/organization-restrict-membership-view'
OrganizationRestrictAttachmentsView = require 'views/enterprise/dashboard/teams-settings/organization-restrict-attachments-view'
ListHeaderComponent = require 'views/enterprise/dashboard/list-header-component'
MemberItemComponent = require 'views/enterprise/dashboard/member-item-component'
InfiniteScroll = require 'views/lib/infinite-scroll'
ItemList = require 'views/enterprise/dashboard/item-list'
PopOver = require 'views/lib/pop-over'
BulkActionProgressDisplay = require 'views/lib/bulk-action-progress-display'
SingleListPopOverComponent = require 'views/enterprise/dashboard/single-list-popover-component'
ItemListPopOverComponent = require 'views/enterprise/dashboard/item-list-popover-component'
PopOverTeamItemComponent = require 'views/enterprise/dashboard/popover-team-item-component'
SingleLineFilterComponent = require 'views/enterprise/dashboard/filters/single-line-filter-component'
ProgressDisplayComponent = require 'views/enterprise/dashboard/bulk-actions/progress-component/display-component'
PendingOrganizationItemComponent = require 'views/enterprise/dashboard/pending-organization-item-component'
BulkActionsTeamOptionsListComponent = require 'views/enterprise/dashboard/bulk-actions/team-options-list-component'
React = require 'react'
ReactDOM = require 'react-dom'
ReactRootComponent = require 'views/internal/react-root-component'
SidebarComponent = require 'views/enterprise/dashboard/sidebar-component'
TabbedPaneView = require 'views/internal/tabbed-pane-view'
TeamItemComponent = require 'views/enterprise/dashboard/team-item-component'
TeamOfMemberComponent = require 'views/enterprise/dashboard/team-of-member-component'
Util = require 'lib/util'
React = require 'react'
View = require 'view'
$ = require 'jquery'
l = require 'lib/localize'
{ maybeDisplayOrgMemberLimitsError } = require 'views/organization/member-limits-error'
mixin = require 'lib/mixin'
bulkActions = require 'views/enterprise/dashboard/bulk-actions/bulk-actions'
template = require 'views/templates/enterprise_detail'
Promise = require 'bluebird'
_ = require 'underscore'
simpleTest = require 'lib/experiments/simple-test'
ldclient = require 'lib/ldclient'

{ LOADED, LOADING_NEW, LOADING_NEXT, LOADING_ERROR } =
  ListComponent.LOADING_STATES

module.exports = class EnterpriseAdminDashboardView extends View
  mixin TabbedPaneView, @

  initialize: ({ initialTab }) ->
    super

    @domContainers = []

    @itemLists =
      members: new ItemList.Member(@model)
      teams: new ItemList.Organization(@model)
      'teams/pending': new ItemList.PendingOrganization(@model)

    @memberTeamItemLists = {}

    @selectedTab = initialTab ? 'members'

    for itemList in _.values(@itemLists)
      @_initLoadingIndicators(itemList)

    @listenTo @model, 'accept:pendingOrganization', (newOrg) =>
      # Adding items invalidates paginated result order
      @itemLists.members = new ItemList.Member(@model)
      @itemLists.teams = new ItemList.Organization(@model)
      @_initLoadingIndicators(@itemLists.members)
      @_initLoadingIndicators(@itemLists.teams)
      @memberTeamItemLists = {}
      @rerender()

      if @selectedTab == 'teams' || @selectedTab == 'teams/pending'
        @_loadUserTypes()

    @listenTo @model.pendingOrganizationList, 'remove', (removedPendingOrganization) =>
      @itemLists['teams/pending'].remove(removedPendingOrganization)
      @rerender()

    @listenTo @model, 'loading:userTypes', @renderDynamic
    @listenTo @model, 'change:userTypes', @renderDynamic
    @listenTo @model, 'change:organizationPrefs', @_renderTeamsSettingsTabOnlySections

  remove: ->
    @infiniteScroll?.destroy()
    super

  _initTab: ->
    PopOver.hide()
    _.invoke(@itemLists, 'resetState')

    if @selectedTab == 'members' || @selectedTab == 'teams' || @selectedTab == 'teams/pending'
      @infiniteScroll?.reset()

  _initInfiniteScroll: ->
    return unless @selectedTab == 'members' || @selectedTab == 'teams' || @selectedTab == 'teams/pending'

    itemList = @getActiveList()
    @infiniteScroll = new InfiniteScroll @listRoot
    @infiniteScroll.on 'nearEnd', =>
      if itemList == @getActiveList()
        itemList?.loadNextPage()

  getActiveList: ->
    @itemLists[@selectedTab]

  render: ->
    @_unmountDomContainers()

    @$el.html template
      displayName: @model.get('displayName')
      enforcesSso: @model.get('prefs').ssoOnly

    @_initTab() if @tabChanged

    @renderStatic()
    @renderDynamic()

    @_initInfiniteScroll()
    @_loadUserTypes()

    @tabChanged = false

    @

  _unmountDomContainers: ->
    while domContainerNode = @domContainers.pop()
      ReactDOM.unmountComponentAtNode(domContainerNode)

  _renderSection: (root, selector, component) ->
    @$(selector).append(root)

    if root not in @domContainers
      @domContainers.push(root)

    el = React.createElement ReactRootComponent, {}, component
    ReactDOM.render(el, root)

  renderStatic: ->
    @reactRoot ?= document.createElement('div')
    @_renderSection(@reactRoot, '.js-content', @getMainContentComponent())

  _renderListTabsOnlySections: ->
    @$('.js-list-header-content').empty()
    @$('.js-list-content').empty()

    return unless @selectedTab == 'members' || @selectedTab == 'teams' || @selectedTab == 'teams/pending'

    @listHeaderRoot ?= document.createElement('div')
    @_renderSection(@listHeaderRoot, '.js-list-header-content', @getListHeaderComponent())

    @listRoot ?= document.createElement('div')
    @_renderSection(@listRoot, '.js-list-content', @getListComponent())

  _renderMembersTabOnlySections: ->
    @$('.js-filters-content').empty()
    @$('.js-bulk-actions-content').empty()

    return unless @selectedTab == 'members'

    @filtersRoot ?= document.createElement('div')
    @_renderSection(@filtersRoot, '.js-filters-content', @getFiltersComponent())

    if @getActiveList().loadingState != LOADING_NEW
      @bulkActionsRoot ?= document.createElement('div')
      @_renderSection(@bulkActionsRoot, '.js-bulk-actions-content', @getBulkActionsComponent())

  _renderTeamsSettingsTabOnlySections: ->
    @$('.js-teams-settings-content').empty()
    return unless @selectedTab == 'settings' && ldclient.variation('enterprise.widePerms', false)


    @teamsSettingsRoot ?= document.createElement('div')
    @_renderSection(@teamsSettingsRoot, '.js-teams-settings-content', @getTeamsSettingsComponent())

  renderDynamic: ->
    @sidebarRoot ?= document.createElement('div')
    @_renderSection(@sidebarRoot, '.js-sidebar-content', @getSidebarComponent())

    @_renderListTabsOnlySections()

    @_renderMembersTabOnlySections()

    @_renderTeamsSettingsTabOnlySections()

  rerender: ->
    @renderDynamic()

  bulkAddToTeam: (team, members, afterEach) ->
    afterEachWrapper = (member, status, membership) =>
      afterEach()
      if status == 'add:added'
        team.addMembership(membership)
        member.orgAdded(team)
        delete @memberTeamItemLists[member.id]

    bulkActions.addToTeam(team, members, afterEachWrapper, { concurrency: 5 })

  bulkRemoveFromTeam: (team, members, removeFromBoards, afterEach) ->
    afterEachWrapper = (member, status) =>
      afterEach()
      if status == 'remove:removed'
        membership = team.getMembershipFor(member.toBackbone())
        team.removeMembership(membership)
        member.orgRemoved(team)
        delete @memberTeamItemLists[member.id]

    bulkActions.removeFromTeam(team, members, afterEachWrapper, { removeFromBoards, concurrency: 5 })

  bulkDeactivateFromTeam: (team, members, afterEach) ->
    afterEachWrapper = (member, status) =>
      afterEach()
      if status == 'deactivate:deactivated'
        wasDeactivated = member.isDeactivated
        team.setOnMembership(member.toBackbone(), { deactivated: true })
        delete @memberTeamItemLists[member.id]
        member.toBackbone().fetchEnterpriseActive(@model.get('id'))
          .then (enterpriseMember) =>
            member.orgDeactivated(team)
            if member.isDeactivated != wasDeactivated
              @rerender()

    bulkActions.deactivateFromTeam(team, members, afterEachWrapper, { concurrency: 5 })

  bulkReactivateInTeam: (team, members, afterEach) ->
    afterEachWrapper = (member, status) =>
      afterEach()
      if status == 'reactivate:reactivated'
        team.setOnMembership(member.toBackbone(), { deactivated: false })
        member.orgReactivated(team)
        delete @memberTeamItemLists[member.id]

    bulkActions.reactivateInTeam(team, members, afterEachWrapper, { concurrency: 5 })

  displayBulkTeamOptions: (el, team) ->
    PopOver.pushView
      elem: el
      alignRight: true
      getViewTitle: -> l(['view title', 'team bulk actions options'], { teamDisplayName: team.displayName }, { raw: true })
      reactElement: React.createElement BulkActionsTeamOptionsListComponent,
        team: team
        getSelectedMembers: @itemLists.members.selectedItems()
        eventHandlers:
          runBulkActionAdd: (members) =>
            for member in members
              if maybeDisplayOrgMemberLimitsError(el, team.toBackbone(), member.toBackbone())
                return

            progressDisplay = new BulkActionProgressDisplay(el, team.toBackbone().get('displayName'), @model.get('displayName'),
              members.length, 'add')
            @bulkAddToTeam team.toBackbone(), members, ->
              progressDisplay.incrementProcessed()
            .then (results) =>
              progressDisplay.done(results)
              @_loadUserTypes()
          runBulkActionRemove: (members, removeFromBoards) =>
            progressDisplay = new BulkActionProgressDisplay(el, team.toBackbone().get('displayName'), @model.get('displayName'),
              members.length, 'remove')
            @bulkRemoveFromTeam team.toBackbone(), members, removeFromBoards, ->
              progressDisplay.incrementProcessed()
            .then (results) =>
              progressDisplay.done(results)
              @_loadUserTypes()
          runBulkActionDeactivate: (members) =>
            progressDisplay = new BulkActionProgressDisplay(el, team.toBackbone().get('displayName'), @model.get('displayName'),
              members.length, 'deactivate')
            @bulkDeactivateFromTeam team.toBackbone(), members, ->
              progressDisplay.incrementProcessed()
            .then (results) =>
              progressDisplay.done(results)
              @_loadUserTypes()
          runBulkActionReactivate: (members) =>
            progressDisplay = new BulkActionProgressDisplay(el, team.toBackbone().get('displayName'), @model.get('displayName'),
              members.length, 'reactivate')
            @bulkReactivateInTeam team.toBackbone(), members, ->
              progressDisplay.incrementProcessed()
            .then (results) =>
              progressDisplay.done(results)
              @_loadUserTypes()

        key: "bulk-add-teams"

  getMainContentComponent: ->
    React.createElement MainContentComponent,
      selectedTab: @selectedTab
      searchCount: @getActiveList()?.totalLength()
      clearSearchValue: @tabChanged || @resetSearch
      onSearchTermChange: @search.bind(@)

  search: (term) ->
    @getActiveList().updateFilter('search', term)

  _loadUserTypes: ->
    @model.loadUserTypes().then => @rerender()

  _initLoadingIndicators: (itemList) ->
    @listenTo itemList, 'loadingStateChanged', @onLoadingStateChanged
    @listenTo itemList, 'loadFirst', @onListLoadFirst

  onLoadingStateChanged: (itemList) ->
    return unless itemList == @getActiveList()
    @rerender()
    if itemList.loadingState == LOADED
      @infiniteScroll?.reset()

  onListLoadFirst: (itemList) ->
    if itemList == @getActiveList()
      @renderStatic()

    # Update sidebar pending count and org-dependent popups
    if itemList in [@itemLists.teams, @itemLists['teams/pending']]
      @renderDynamic()

  onTeamsOfMemberPopoverClick: (el, renderableMember) =>
    return unless renderableMember.enterpriseOrgCount > 0

    @memberTeamItemLists[renderableMember.id] ?=
      new ItemList.OrganizationForMember @model,
        renderableMember.toBackbone()

    PopOver.toggle
      elem: el
      getViewTitle: -> l(['view title', 'teams'])
      reactElement: React.createElement GroupListPopOverComponent,
        modelName: 'teams'
        itemList: @memberTeamItemLists[renderableMember.id]
        renderableMember: renderableMember
        itemComponent: TeamOfMemberComponent
        key: "#{ renderableMember.username }-teams"

    return

  onSelectMemberClick: (item, { selectRange }) ->
    @getActiveList().itemSelected(item, selectRange)
    # updates BulkActionsComponent to display the new count
    @rerender()

  getListComponent: ->
    if @selectedTab == 'members'
      React.createElement ListComponent,
        loadingState: @getActiveList().loadingState
        items: @getActiveList().items()
        itemComponent: MemberItemComponent
        itemEventHandlers:
          onSelectCheckboxClick: @onSelectMemberClick.bind(@)
          onPopoverClick: @onTeamsOfMemberPopoverClick
    else if @selectedTab == 'teams'
      React.createElement ListComponent,
        loadingState: @getActiveList().loadingState
        items: @getActiveList().items()
        itemComponent: TeamItemComponent
    else if @selectedTab == 'teams/pending'
      React.createElement ListComponent,
        loadingState: @getActiveList().loadingState
        items: @getActiveList().items()
        itemComponent: PendingOrganizationItemComponent
        itemDependencies:
          availableLicenses: @model.getAvailableLicenses()
        itemEventHandlers:
          onViewNewBillableMembers: (el, pendingOrganization) =>
            PopOver.toggle
              elem: el
              getViewTitle: -> l(['view title', 'new-billable-members'])
              reactElement: React.createElement PendingOrganizationMembersComponent,
                members: pendingOrganization.transferability.newBillableMembers
                key: "pending-organization-new-billable-members-#{ pendingOrganization.date }"
          onViewUntransferredMembers: (el, pendingOrganization) =>
            PopOver.toggle
              elem: el
              getViewTitle: -> l(['view title', 'untransferred-members'])
              reactElement: React.createElement PendingOrganizationMembersComponent,
                members: pendingOrganization.transferability.untransferredMembers
                key: "pending-organization-untransferred-members-#{ pendingOrganization.date }"
          onDecline: (el, pendingOrganization) =>
            PopOver.toggle
              elem: el
              getViewTitle: -> l(['view title', 'decline-add-to-enterprise'])
              reactElement: React.createElement HandlePendingOrganizationComponent,
                acceptOrDecline: 'decline'
                onClick: =>
                  @model.declinePendingOrganization(pendingOrganization)
                  .then ->
                    PopOver.hide()
                key: "decline-pending-organization-#{ pendingOrganization.date }"
          onAccept: (el, pendingOrganization) =>
            PopOver.toggle
              elem: el
              getViewTitle: -> l(['view title', 'confirm-add-to-enterprise'])
              reactElement: React.createElement HandlePendingOrganizationComponent,
                acceptOrDecline: 'accept'
                currentTotal: @_getEnterpriseMembersCount()
                newBillableMembersCount: pendingOrganization.transferability.newBillableMembers.length
                max: @_getMaxMembers()
                onClick: =>
                  @model.acceptPendingOrganization(pendingOrganization)
                  .then ->
                    PopOver.hide()
                key: "accept-pending-organization-#{ pendingOrganization.date }"

  getTeamsSettingsComponent: ->
    React.createElement TeamsSettingsComponent,
      boardVisibilityRestrictions: @model.get('organizationPrefs')?.boardVisibilityRestrict
      openChangeBoardVisRestrictions:
        public: @openChangeBoardVisPublicRestrictions.bind(@)
        org: @openChangeBoardVisOrgRestrictions.bind(@)
        private: @openChangeBoardVisPrivateRestrictions.bind(@)
      externalMembersDisabled: @model.get('organizationPrefs')?.externalMembersDisabled
      openChangeExternalMembersDisabled: @openChangeExternalMembersDisabled.bind(@)
      permissionLevel: @model.get('organizationPrefs')?.permissionLevel
      openChangeVisibility: @openChangeVisibility.bind(@)
      orgInviteRestrict: @model.get('organizationPrefs')?.orgInviteRestrict
      openChangeMembershipRestrictions: @openChangeMembershipRestrictions.bind(@)
      attachmentRestrictions: @model.getAttachmentRestrictions()
      openChangeAttachmentRestrictions: @openChangeAttachmentRestrictions.bind(@)

  openChangeBoardVisPublicRestrictions: (el) ->
    PopOver.toggle
      elem: el
      alignRight: true
      view: new OrganizationRestrictBoardVisibilityView({ @model, @modelCache, visibility: 'public' })
    return

  openChangeBoardVisOrgRestrictions: (el) ->
    PopOver.toggle
      elem: el
      alignRight: true
      view: new OrganizationRestrictBoardVisibilityView({ @model, @modelCache, visibility: 'org' })
    return

  openChangeBoardVisPrivateRestrictions: (el) ->
    PopOver.toggle
      elem: el
      alignRight: true
      view: new OrganizationRestrictBoardVisibilityView({ @model, @modelCache, visibility: 'private' })
    return

  openChangeExternalMembersDisabled: (el) ->
    PopOver.toggle
      elem: el
      alignRight: true
      maxWidth: 370
      view: new OrganizationRestrictExternalMembersView({ @model, @modelCache })
    return

  openChangeVisibility: (el) ->
    PopOver.toggle
      elem: el
      alignRight: true
      view: new OrganizationRestrictVisibilityView({ @model, @modelCache })
    return

  openChangeMembershipRestrictions: (el) ->
    PopOver.toggle
      elem: el
      alignRight: true
      view: new OrganizationRestrictMembershipView({ @model, @modelCache })
    return

  openChangeAttachmentRestrictions: (el) ->
    PopOver.toggle
      elem: el
      alignRight: true
      view: new OrganizationRestrictAttachmentsView({ @model, @modelCache })
    return

  getSidebarComponent: ->
    React.createElement SidebarComponent,
      pendingRequestsCount: @itemLists['teams/pending'].totalLength()
      userTypesLoading: @model.userTypesLoading
      teamsCount: @itemLists.teams.totalLength()
      membersCount: @_getTotalUsersCount()
      enterpriseMembersCount: @_getEnterpriseMembersCount()
      outsideCollaboratorsCount: @_getOutsideCollaboratorsCount()
      ssoUsersCount: @_getSsoUsersCount()
      enterpriseMaxMembers: @_getMaxMembers()
      deactivatedCount: @_getDeactivatedCount()
      nearMaxMembers: @_isNearMaxMembers()
      exceedingMaxMembers: @_isExceedingMaxMembers()
      selectedTab: @selectedTab
      onSidebarTabClick: (newTab) =>
        @selectedTab = newTab
        @tabChanged = true

        Controller.navigate(Controller.getEnterpriseAdminDashboardUrl(@model, newTab))

        @render()

  getBulkActionsComponent: ->
    React.createElement BulkActionsComponent,
      count: @itemLists.members.selectedItemsLength()
      totalCount: @itemLists.members.lengthOfSearch()
      onTeamsPopoverClick: (el) =>
        return unless @itemLists.teams.totalLength() > 0

        PopOver.toggle
          elem: el
          maxWidth: 410
          alignRight: true
          getViewTitle: -> l 'add or remove from team'
          reactElement: React.createElement ItemListPopOverComponent,
            modelName: 'teams'
            itemList: @itemLists.teams
            itemComponent: PopOverTeamItemComponent
            itemEventHandlers:
              onClick: (team) =>
                @displayBulkTeamOptions(el, team)
            key: "bulk-teams"

        return
      hasTeams: @itemLists.teams.totalLength() > 0
      allItemsAreSelected: @itemLists.members.selectedItemsLength() == @itemLists.members.lengthOfSearch()
      allVisibleItemsAreSelected: @itemLists.members.selectedItemsLength() >= @itemLists.members.items().length
      onSelectAll: =>
        @itemLists.members.selectAll()
        @rerender()
      onClearAll: =>
        @itemLists.members.deselect()
        @rerender()
      hasSelectedItems: @itemLists.members.selectedItemsLength() > 0

  getListHeaderComponent: ->
    itemList = @getActiveList()

    React.createElement ListHeaderComponent,
      isFiltering: @getActiveList().getActiveFilters().length > 0
      title: l(['view title', @selectedTab])
      count: itemList.lengthOfSearch()
      allCount: itemList.totalLength()
      error: itemList.loadingState == LOADING_ERROR
      isSortable: @selectedTab == 'members'
      sortField: @getActiveList().getSortField?()
      sortOrder: @getActiveList().getSortOrder?()
      onSortClick: (el) =>
        PopOver.toggle
          elem: el
          getViewTitle: -> l(['view title', 'sort by'])
          reactElement: React.createElement SingleListPopOverComponent,
            items: [
              { name: 'A-Z',  sortField: 'fullName', sortOrder: 'ascending' }
              { name: 'Z-A', sortField: 'fullName', sortOrder: 'descending' }
              { name: 'least-recently-active',  sortField: 'dateLastActive', sortOrder: 'ascending' }
              { name: 'most-recently-active', sortField: 'dateLastActive', sortOrder: 'descending' }
            ]
            itemComponent: SingleLineFilterComponent
            itemEventHandlers:
              onClick: ({ sortField, sortOrder }) =>
                PopOver.hide()
                @getActiveList().sort(sortField, sortOrder)
                @rerender()
            itemInlineButtons:
              isActive: ({ sortField, sortOrder })=>
                @getActiveList().getSortField() == sortField && \
                  @getActiveList().getSortOrder() == sortOrder
            key: "sort-by-activity"

        return
      onShowAll: =>
        @search()
        @resetSearch = true
        @_clearFiltersExceptSearch()
        @getActiveList().clearFilter('search')
        @renderStatic()
        @resetSearch = false

  _getTotalUsersCount: ->
    @model.get('userTypes')?.all

  _getEnterpriseMembersCount: ->
    @model.get('userTypes')?.member

  _getDeactivatedCount: ->
    @model.get('userTypes')?.none

  _getOutsideCollaboratorsCount: ->
    @model.get('userTypes')?.collaborator

  _getSsoUsersCount: ->
    @model.get('userTypes')?.saml

  _getMaxMembers: ->
    @model.getPref('maxMembers')

  _isNearMaxMembers: ->
    max = @_getMaxMembers()
    return false if !max?
    count = @_getEnterpriseMembersCount()
    # “near” means < 5% capacity remaining, or 20 seats, whichever is less
    max - count <= Math.min(Math.ceil(max * 0.05), 20)

  _isExceedingMaxMembers: ->
    max = @_getMaxMembers()
    max? && max < @_getEnterpriseMembersCount()

  # this doesn't clear search because the grouping of the
  # buttons in the ui suggests that Clear Filters will not operate on it
  _clearFiltersExceptSearch: ->
    PopOver.hide()
    for filter in ['teams', 'userType', 'hasTransferred']
      @getActiveList().clearFilter(filter)

  getFiltersComponent: ->
    filterPopoverParams = (filterName, el, {
      items
      itemList
      itemComponent
      optionIsActive
      onFilterOptionClick
    }) =>
      isActive = filterName in @getActiveList().getActiveFilters()
      componentType = if itemList
          ItemListPopOverComponent
        else
          SingleListPopOverComponent

      elem: el
      alignRight: false
      getViewTitle: -> l(['view title', filterName])
      hideHeader: true
      displayType: 'filter-popover'
      reactElement: React.createElement componentType,
        modelName: filterName
        isActive: isActive
        buttonData: if isActive
          componentClass: FilterPopOverButtonComponent
          onClick: =>
            PopOver.hide()
            @getActiveList().clearFilter(filterName)
            @rerender()
        items: items
        itemList: itemList
        itemComponent: itemComponent
        itemInlineButtons:
          isActive: optionIsActive
        itemEventHandlers:
          onClick: onFilterOptionClick
        key: "#{ filterName }-filter"

    React.createElement FiltersComponent,
      hasTeams: @itemLists.teams.totalLength() > 0
      activeFilters: @getActiveList().getActiveFilters()
      clickHandlers:
        team: (el) =>
          return unless @itemLists.teams.totalLength() > 0

          makeParams = => filterPopoverParams 'teams', el,
            itemList: @itemLists.teams
            itemComponent: PopOverTeamItemComponent
            onFilterOptionClick: (team) =>
              @getActiveList().toggleFilter('teams', team.id)
              @rerender()
              PopOver.load(makeParams())
            optionIsActive: (team) =>
              team.id in @getActiveList().getFilterValueMap()['teams']

          PopOver.toggle(makeParams())

          return
        userType: (el) =>
          makeParams = => filterPopoverParams 'userType', el,
            items: [
              { name: 'member' }
              { name: 'collaborator' }
              { name: 'saml' }
              { name: 'none' }
            ]
            itemComponent: SingleLineFilterComponent
            onFilterOptionClick: (userType) =>
              @getActiveList().toggleFilter('userType', userType.name)
              @rerender()
              PopOver.load(makeParams())
            optionIsActive: (userType) =>
              userType.name in @getActiveList().getFilterValueMap()['userType']

          PopOver.toggle(makeParams())

          return
        hasTransferred: (el) =>
          makeParams = => filterPopoverParams 'hasTransferred', el,
            items: [
              { name: 'transferred' }
              { name: 'not-transferred' }
            ]
            itemComponent: SingleLineFilterComponent
            optionIsActive: (option) =>
              currentValue = @getActiveList().getFilterValueMap()['hasTransferred']
              return false unless currentValue?
              if option.name == 'transferred'
                currentValue
              else
                !currentValue
            onFilterOptionClick: (clicked) =>
              currentValue = @getActiveList().getFilterValueMap()['hasTransferred']

              if !currentValue?
                @getActiveList().updateFilter('hasTransferred', clicked.name == 'transferred')
              else
                clickedOnAlreadyActive = if currentValue
                    clicked.name == 'transferred'
                  else
                    clicked.name == 'not-transferred'

                if clickedOnAlreadyActive
                  @getActiveList().clearFilter('hasTransferred')
                else
                  @getActiveList().updateFilter('hasTransferred', clicked.name == 'transferred')

              @rerender()
              PopOver.load(makeParams())

          PopOver.toggle(makeParams())

          return
        clear: =>
          @_clearFiltersExceptSearch()
          @rerender()



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/enterprise-admin-dashboard-view.coffee